export default "__VITE_ASSET__BpUoYR0G__"